import React from "react";
import { useIsMobile } from "@tlc/ui/useIsMobile";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TransitionProps } from "@mui/material/transitions";
import { DialogWithDataProps } from "@tlc/ui/dialog/useDialog";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface OverdriveIFrameDialogData {
  src: string;
}

export const OverdriveIFrameDialog = ({
  open,
  onClose,
  data: { src },
}: DialogWithDataProps<OverdriveIFrameDialogData>) => {
  const { translate } = useLanguage();
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <Dialog
          fullScreen
          open={open}
          onClose={onClose}
          slots={{
            transition: Transition,
          }}
        >
          <AppBar
            sx={{
              position: "relative",
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <Toolbar sx={{ backgroundColor: "transparent" }}>
              <IconButton
                edge="start"
                color="default"
                onClick={onClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, color: "#000" }}
                variant="h6"
                component="div"
              >
                {translate("checkoutEResourceDialogTitle")}
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent sx={{ overflowY: "hidden" }}>
            <iframe
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              src={src}
            ></iframe>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog
          fullScreen={false}
          open={open}
          onClose={onClose}
          maxWidth={false}
          scroll="body"
        >
          <DialogTitle>{translate("checkoutEResourceDialogTitle")}</DialogTitle>
          <DialogContent
            sx={{
              minWidth: 472,
              flex: 1,
              p: 0,
            }}
          >
            <iframe
              style={{
                width: "100%",
                height: "100%",
                minHeight: "632px",
                border: "none",
              }}
              src={src}
            ></iframe>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>{translate("close")}</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
